// =============================================================================
//  Copyright   : 2018 semantics GmbH
//  Date        : $Date: 2024-07-04 17:21:52 +0200 (Thu, 04 Jul 2024) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 144386 $
//  Purpose     : call i18n apis
// =============================================================================
// ---Third-party imports
import {put, takeEvery, call} from 'redux-saga/effects'

// ---Framework imports
import {has, get} from 'ldash'
import {selectInitCacheKeys} from 'uix/selectors'
import {select, recoveredCachedConfigs} from 'uix/sagas'
import Api from 'uix/api'
import {setLanguage} from './actions'
import log from 'uix/logging'

// ---Globals
function* switchLanguage({payload}) {
  let language = payload.language
  let root = yield select()
  let cacheKeys = selectInitCacheKeys(root)

  let dname = root.meta.request.dname
  let i18n = get(root.config.ddata[dname].i18n, language)
  if (!i18n) {
    let {data: ddata, error} = yield call(Api.post, '/api/loadi18n', {
      language,
      cacheKeys: JSON.stringify(cacheKeys),
    })
    if (!error) {
      ddata = recoveredCachedConfigs(root.config.ddataCache, ddata)
      let k = `i18n_${language}`
      let newCk = {[k]: ddata.cacheKeys[k]}
      yield put(setLanguage({language, dname, i18ndata: ddata.i18n, cacheKeys: newCk}))
    }
  } else {
    yield put(setLanguage({language, i18ndata: {[language]: i18n}}))
  }

  // notify server session
  yield call(Api.post, '/api/changeLanguage', {lang: language})
}

export const sagas = {
  switchLanguage: takeEvery('SWITCH_LANGUAGE', switchLanguage),
}
